<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "InfinityChallengeStartModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    challenge() {
      return InfinityChallenge(this.id);
    },
    challengeIsCompleted() {
      return this.challenge.isCompleted;
    },
    message() {
      return `Вы сделаете Большой Хруст (если возможно) и начнёте новую Бесконечность внутри Челленджа со всеми
        относящимися к Челленджу ограничениями и модификаторами активными.
        Чтобы выполнить Челлендж${this.challengeIsCompleted ? "" : " и получить награду"},
        Вы должны достигнуть цель Челленджа равную
        ${format(InfinityChallenge(this.id).goal)} Антиматерии.
        Вы не начинаете с Бустами Измерений или Галактиками, независимо от улучшений.`;
    },
    entranceLabel() {
      return `Вы начинаете Бесконечный Челлендж ${this.id}`;
    },
    reward() {
      let rewardDescription = this.challenge._config.reward.description;
      if (typeof rewardDescription === "function") {
        rewardDescription = rewardDescription();
      }
      return `Награда за прохождение этого Челленджа равна: ${rewardDescription}`;
    },
    condition() {
      let conditionOfChallenge = this.challenge._config.description;
      if (typeof conditionOfChallenge === "function") {
        conditionOfChallenge = conditionOfChallenge();
      }
      return `Внутри этого Бесконечного Челленджа, ${conditionOfChallenge}`;
    }
  },
  created() {
    this.on$(GAME_EVENT.ETERNITY_RESET_AFTER, this.emitClose);
    this.on$(GAME_EVENT.REALITY_RESET_AFTER, this.emitClose);
  },
  methods: {
    handleYesClick() {
      this.challenge.start();
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="challenges"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ entranceLabel }}
    </template>
    <div class="c-modal-message__text">
      {{ message }}
      <br><br>
      {{ condition }}
    </div>
    <div
      v-if="!challengeIsCompleted"
      class="c-modal-message__text"
    >
      <br>
      {{ reward }}
    </div>
    <template #confirm-text>
      Начать
    </template>
  </ModalWrapperChoice>
</template>
